import React, { Component } from 'react';
import { Grid, Header, Image, Segment, Transition } from 'semantic-ui-react';

const newFounder=require('../../img/newFounderItems.svg');

class Heading extends Component {
  render() {
    return (
      <Segment style={{ padding: '7em 0em', backgroundColor: '#FFB805', position: 'relative' }} vertical>
        <Grid container stackable textAlign='left' style={{padding: '6em 0em'}}>
          <Grid.Row>
            <Grid.Column width={7} computer={7} mobile={16} tablet={8}>
              <Transition animation='swing up' duration={1500} visible={true} transitionOnMount={true}>
                <Header as='h1' style={{ fontSize: '3.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>
                  Designed for millennial entrepreneurs, <br/> by millennials.
                </Header>
              </Transition>
              <Header as='h5' style={{ fontSize: '1.5em', fontFamily: 'Montserrat', color: '#E94A7E'}}>
                No more stuffy suits and confusing
                insurance jargon. Communication,
                transparency, and security help you <br/>
                get your business insured, faster.
              </Header>
            </Grid.Column>
            <Grid.Column width={9} computer={9} mobile={16} tablet={8} >
              <Transition animation='fly down' duration={1500} visible={true} transitionOnMount={true}>
                <Image size='huge' floated='right' src={newFounder}/>
              </Transition>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
};

export default Heading;



// WEBPACK FOOTER //
// ./src/js/Home/Heading.js